/* Yatskia cart personalization. Replace the previous asset in full. */
(() => {
  if (window.YatskiaCartGuard) return;

  const propertyKeys = [
      "Engraving Name",
      "Date of Birth",
      "Date of Passing",
      "Memorial Message",
      "Design Notes",
      "Portrait Photo",
      "Personalization",
      "Design Placement",
      "AI Preview Status",
      "_Personalization Mode",
      "_Personalization Submission",
      "AI Design Preview",
      "_AI Preview",
      "_AI Draft Preview",
      "_AI Preview ID",
      "_AI Reference Photo",
    ],
    previewKeys = [
      "AI Design Preview",
      "_AI Preview",
      "_AI Draft Preview",
      "_AI Preview ID",
      "_AI Reference Photo",
    ],
    normalizeProperties = (value) =>
      Array.isArray(value) ? Object.fromEntries(value) : value || {},
    count = (text) =>
      typeof Intl.Segmenter == "function"
        ? [
            ...new Intl.Segmenter(void 0, { granularity: "grapheme" }).segment(
              text,
            ),
          ].length
        : [...text].length,
    equal = (a, b) =>
      JSON.stringify(Object.entries(a).sort()) ===
      JSON.stringify(Object.entries(b).sort());

  function dateISO(value) {
    if (!value) return "";

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/),
      year,
      month,
      day;

    if (match) [, year, month, day] = match.map(Number);
    else {
      if (
        ((match = String(value).match(/^([A-Z][a-z]{2}) (\d{1,2}), (\d{4})$/)),
        !match || !months.includes(match[1]))
      )
        return null;

      ((year = Number(match[3])),
        (month = months.indexOf(match[1]) + 1),
        (day = Number(match[2])));
    }

    const date = new Date(Date.UTC(year, month - 1, day));

    return date.getUTCFullYear() !== year ||
      date.getUTCMonth() !== month - 1 ||
      date.getUTCDate() !== day
      ? null
      : `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  function displayDate(value) {
    if (!value) return "";

    const iso = dateISO(value);

    if (!iso) throw Error("Please enter a complete, valid date.");

    const [year, month, day] = iso.split("-").map(Number);

    return `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][month - 1]} ${day}, ${year}`;
  }

  const engraving = (p) =>
    [
      p["Engraving Name"],
      [p["Date of Birth"], p["Date of Passing"]]
        .filter(Boolean)
        .join(" \u2013 "),
      p["Memorial Message"],
    ].filter(Boolean).join(`
`);

  function buildProperties(original, fields, limit, today) {
    const next = { ...original };

    if (!fields.enabled)
      return (
        propertyKeys.forEach((key) => delete next[key]),
        (next.Personalization = "Not personalized"),
        next
      );

    if (
      (fields.birth && dateISO(fields.birth) === null) ||
      (fields.passing && dateISO(fields.passing) === null)
    )
      throw Error("Please enter complete, valid dates.");

    if (
      (fields.birth && fields.birth > today) ||
      (fields.passing && fields.passing > today)
    )
      throw Error("Dates cannot be in the future.");

    if (fields.birth && fields.passing && fields.birth > fields.passing)
      throw Error("The birth date must be on or before the passing date.");

    const values = {
      "Engraving Name": fields.name.trim(),
      "Date of Birth": fields.preserveBirth
        ? original["Date of Birth"] || ""
        : displayDate(fields.birth),
      "Date of Passing": fields.preservePassing
        ? original["Date of Passing"] || ""
        : displayDate(fields.passing),
      "Memorial Message": fields.tribute.trim(),
      "Design Notes": fields.notes.trim(),
    };

    if (
      count(values["Memorial Message"]) > 30 ||
      count(values["Design Notes"]) > 300
    )
      throw Error(
        "Keep the tribute within 30 characters and placement notes within 300.",
      );

    if (count(engraving(values)) > limit)
      throw Error(
        `Please shorten the name, dates or tribute to ${limit} engraving characters. Spaces and displayed dates count.`,
      );

    if (!Object.values(values).some(Boolean) && !original["Portrait Photo"])
      throw Error(
        "Add a name, date, tribute, instruction or photo, or switch personalization off.",
      );

    const changed = Object.entries(values).some(
      ([key, value]) => String(original[key] || "") !== value,
    );

    return (
      Object.entries(values).forEach(([key, value]) => {
        value ? (next[key] = value) : delete next[key];
      }),
      (next.Personalization = "Personalized urn"),
      (next["Design Placement"] = values["Design Notes"]
        ? "Follow Design Notes"
        : "Automatic layout"),
      (changed || original.Personalization !== "Personalized urn") &&
        (previewKeys.forEach((key) => delete next[key]),
        (next["AI Preview Status"] = "No AI preview approved"),
        (next["_Personalization Mode"] = next["Portrait Photo"]
          ? "Photo supplied - proof required"
          : "Text only")),
      next
    );
  }

  const editors = () => [...document.querySelectorAll("yatskia-cart-editor")];

  const activeEditor = () =>
    editors().find((el) => el.dirty || el.saving || el.uncertain);

  const note = () => document.querySelector("yatskia-cart-note");

  let quantityPending = false;
  let quantityTimer;
  let leaving = false;

  const quantityBusy = () =>
    quantityPending || !!document.querySelector(".cart__items--disabled");

  const blocked = () =>
    !!activeEditor() || quantityBusy() || !!(note()?.dirty || note()?.saving);

  function explain() {
    const editor = activeEditor();

    if (editor) {
      editor.querySelector("details").open = true;

      editor.error(
        editor.uncertain
          ? "Reload your cart to confirm the last update before continuing."
          : editor.saving
            ? "Please wait while personalization is saved."
            : "Save or cancel your personalization changes before continuing.",
      );
    } else {
      const target =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");

      if (target) {
        target.textContent = quantityBusy()
          ? "Please wait while your cart updates."
          : "Save your order note before continuing. Use Retry if the save failed.";

        target.focus?.();
      }
    }
  }

  function sync() {
    const active = activeEditor();

    editors().forEach((editor) => {
      const fields = editor.querySelector("[data-editor-fields]");

      if (fields)
        fields.disabled =
          !editor.ready ||
          editor.saving ||
          editor.uncertain ||
          !!(active && active !== editor) ||
          quantityBusy() ||
          !!note()?.saving;
    });

    const stop = blocked();

    document.querySelectorAll('button[name="checkout"]').forEach((button) => {
      button.setAttribute("aria-disabled", String(stop || button.disabled));
    });

    document
      .querySelectorAll(".additional-checkout-buttons, [data-y-express]")
      .forEach((el) => {
        el.inert = stop;
        el.setAttribute("aria-disabled", String(stop));
      });

    document.querySelectorAll("[data-y-express-status]").forEach((el) => {
      el.hidden = !stop;
    });

    document.dispatchEvent(new CustomEvent("yatskia:cart-state"));
  }

  window.YatskiaCartGuard = {
    sync,
    blocked,
    explain,
    quantityBusy,
    activeEditor,
  };

  function stop(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    explain();
  }

  document.addEventListener(
    "click",
    (event) => {
      const target =
        event.target instanceof Element
          ? event.target
          : event.target.parentElement;

      if (target?.closest("[data-cart-reload]")) {
        leaving = true;
        return;
      }

      const control = target?.closest(
        'button[name="checkout"], cart-remove-button, cart-items .quantity__button, cart-drawer-items .quantity__button, [data-cart-upsell-add], .additional-checkout-buttons',
      );

      if (control && blocked()) stop(event);
    },
    true,
  );

  document.addEventListener(
    "submit",
    (event) => {
      if (
        event.target.id === "cart" ||
        event.target.closest("cart-items, cart-drawer-items") ||
        event.submitter?.name === "checkout"
      ) {
        if (blocked()) stop(event);
      }
    },
    true,
  );

  document.addEventListener(
    "beforeinput",
    (event) => {
      if (
        event.target.matches?.('input[name="updates[]"]') &&
        (activeEditor() ||
          note()?.dirty ||
          note()?.saving ||
          document.querySelector(".cart__items--disabled"))
      )
        stop(event);
    },
    true,
  );

  document.addEventListener(
    "change",
    (event) => {
      if (!event.target.matches?.('input[name="updates[]"]')) return;

      if (
        activeEditor() ||
        note()?.dirty ||
        note()?.saving ||
        document.querySelector(".cart__items--disabled")
      ) {
        event.target.value = event.target.getAttribute("value");
        stop(event);
        return;
      }

      quantityPending = true;
      clearTimeout(quantityTimer);

      quantityTimer = setTimeout(() => {
        quantityPending = false;
        sync();
      }, 1200);

      sync();
    },
    true,
  );

  window.addEventListener("beforeunload", (event) => {
    if (!leaving && (activeEditor() || note()?.dirty || note()?.saving)) {
      event.preventDefault();
      event.returnValue = "";
    }
  });

  // Keep theme AJAX section rendering from replacing an unsaved editor.
  customElements.whenDefined("cart-items").then(() => {
    const proto = customElements.get("cart-items").prototype;

    if (proto.yatskiaGuarded) return;

    proto.yatskiaGuarded = true;

    const update = proto.updateQuantity;

    proto.updateQuantity = function (...args) {
      if (
        activeEditor() ||
        note()?.dirty ||
        note()?.saving ||
        document.querySelector(".cart__items--disabled")
      ) {
        explain();
        return;
      }

      quantityPending = false;
      clearTimeout(quantityTimer);

      return update.apply(this, args);
    };

    const refresh = proto.onCartUpdate;

    if (refresh)
      proto.onCartUpdate = function (...args) {
        if (activeEditor()) {
          explain();
          return;
        }

        return refresh.apply(this, args);
      };
  });

  class CartEditor extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;

      this.controls = Object.fromEntries(
        [...this.querySelectorAll("[data-cart-field]")].map((el) => [
          el.dataset.cartField,
          el,
        ]),
      );

      this.toggle = this.querySelector("[data-cart-personalize]");

      try {
        this.original = normalizeProperties(
          JSON.parse(
            this.querySelector("[data-cart-properties]").textContent || "{}",
          ),
        );
      } catch {
        this.uncertain = true;
        this.error("Personalization could not be loaded. Reload your cart.");
        this.querySelector("[data-cart-reload]").hidden = false;
        return;
      }

      this.initialEnabled = this.toggle.checked;
      this.ready = true;
      this.reset();

      this.addEventListener("input", () => this.changed());
      this.addEventListener("change", () => this.changed());

      this.querySelector("[data-cart-save]").addEventListener("click", () =>
        this.save(),
      );

      this.querySelector("[data-cart-cancel]").addEventListener("click", () => {
        if (this.saving || this.uncertain) return;

        this.reset();
        this.querySelector("details").open = false;
        sync();
      });

      sync();
    }

    today() {
      const d = new Date();

      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    }

    reset() {
      this.toggle.checked = this.initialEnabled;

      const keys = {
        name: "Engraving Name",
        birth: "Date of Birth",
        passing: "Date of Passing",
        tribute: "Memorial Message",
        notes: "Design Notes",
      };

      for (const [key, el] of Object.entries(this.controls)) {
        const value = String(this.original[keys[key]] || "");

        if (key === "birth" || key === "passing") {
          const iso = dateISO(value);

          el.value = iso || "";
          el.dataset.preserve = String(iso === null);
          el.disabled = iso === null;
          el.max = this.today();

          if (iso === null)
            el.title =
              "Your existing date is preserved. Contact us to change its format.";
        } else el.value = value;
      }

      this.dirty = false;
      this.error("");
      this.updateCount();
    }

    fields() {
      return {
        ...Object.fromEntries(
          Object.entries(this.controls).map(([key, el]) => [key, el.value]),
        ),
        enabled: this.toggle.checked,
        preserveBirth: this.controls.birth.dataset.preserve === "true",
        preservePassing: this.controls.passing.dataset.preserve === "true",
      };
    }

    changed() {
      this.dirty = true;
      this.error("");
      this.updateCount();
      sync();
    }

    updateCount() {
      const f = this.fields();

      const values = {
        "Engraving Name": f.name,
        "Memorial Message": f.tribute,
      };

      try {
        values["Date of Birth"] = f.preserveBirth
          ? this.original["Date of Birth"]
          : displayDate(f.birth);

        values["Date of Passing"] = f.preservePassing
          ? this.original["Date of Passing"]
          : displayDate(f.passing);
      } catch {}

      this.querySelector("[data-cart-count]").textContent = f.enabled
        ? `${count(engraving(values))} / ${this.dataset.limit} engraving characters. Dates and spaces count. Tribute: up to 30; placement notes: up to 300.`
        : "Saving will remove personalization, including any attached portrait and preview, from this item.";

      const group = this.querySelector("[data-personalize-fields]");

      if (group) group.hidden = !f.enabled;
    }

    error(message) {
      const el = this.querySelector("[data-cart-edit-error]");

      el.textContent = message;

      if (message) {
        el.focus({ preventScroll: true });
        el.scrollIntoView({ block: "nearest" });
      }
    }

    async save() {
      if (this.saving || this.uncertain) return;

      if (quantityBusy() || note()?.saving || note()?.dirty) {
        explain();
        return;
      }

      if (
        editors().some(
          (el) => el !== this && (el.dirty || el.saving || el.uncertain),
        )
      ) {
        explain();
        return;
      }

      let properties;

      try {
        if (Object.values(this.controls).some((el) => el.validity?.badInput))
          throw new Error("Please enter complete dates.");

        properties = buildProperties(
          this.original,
          this.fields(),
          Number(this.dataset.limit),
          this.today(),
        );
      } catch (error) {
        this.error(error.message);
        return;
      }

      if (equal(properties, this.original)) {
        this.dirty = false;
        this.querySelector("details").open = false;
        sync();
        return;
      }

      this.saving = true;
      this.dirty = true;
      this.error("");
      sync();

      const root = window.Shopify?.routes?.root || "/";
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);

      let submitted = false;
      let success = false;

      try {
        const currentResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: "application/json" },
          cache: "no-store",
          signal: controller.signal,
        });

        if (!currentResponse.ok)
          throw new Error(
            "Could not check your cart. Please try saving again.",
          );

        const current = await currentResponse.json();

        const line = current.items.find(
          (item) => item.key === this.dataset.lineKey,
        );

        if (
          !line ||
          !equal(normalizeProperties(line.properties), this.original)
        ) {
          this.uncertain = true;

          throw new Error(
            "This item changed. Reload your cart before editing it again.",
          );
        }

        submitted = true;

        const response = await fetch(`${root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: line.key,
            quantity: line.quantity,
            properties,
          }),
          signal: controller.signal,
        });

        if (!response.ok) {
          if (response.status >= 400 && response.status < 500)
            submitted = false;

          const result = await response.json().catch(() => ({}));

          throw new Error(
            typeof result.description === "string"
              ? result.description
              : "Could not save personalization. Please try again.",
          );
        }

        const updated = await response.json();

        const matchingQuantity = updated.items
          .filter(
            (item) =>
              String(item.variant_id) === this.dataset.variant &&
              equal(normalizeProperties(item.properties), properties),
          )
          .reduce((sum, item) => sum + item.quantity, 0);

        if (
          updated.item_count !== current.item_count ||
          matchingQuantity < line.quantity
        )
          throw new Error("Could not verify the update.");

        success = true;
        this.dirty = false;
        leaving = true;

        // Reload after confirmed success so line keys, review text, discounts and drawer agree.
        window.location.reload();
      } catch (error) {
        this.uncertain = this.uncertain || submitted;
        this.dirty = true;
        this.querySelector("[data-cart-reload]").hidden = !this.uncertain;

        this.error(
          this.uncertain
            ? "We could not confirm the update. Reload your cart to check this item before continuing."
            : error.name === "AbortError"
              ? "The request timed out. Your changes are still here. Try saving again."
              : error.message,
        );
      } finally {
        clearTimeout(timer);

        if (!success) this.saving = false;

        sync();
      }
    }
  }

  if (!customElements.get("yatskia-cart-editor"))
    customElements.define("yatskia-cart-editor", CartEditor);

  function observe() {
    const root = document.body;
    let scheduled = false;

    new MutationObserver(() => {
      if (scheduled) return;

      scheduled = true;

      queueMicrotask(() => {
        scheduled = false;
        sync();
      });
    }).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    sync();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", observe, { once: true });
  else observe();
})();